import React, { useState } from 'react';
import PackingSlip from './PackingSlip';
import { Package, PictureInPicture } from '@phosphor-icons/react';
import { Button, Collapse, Tooltip } from 'antd';
import { MdClose } from 'react-icons/md';
import { useViewerStore } from '../../../../store/store';

const PackingSlipPopup: React.FC = () => {
    const { sceneViewer } = useViewerStore();

    const [isMaximized, setIsMaximized] = useState(true);

    const handleMaximize = () => {
        setIsMaximized(true);
    };

    const handleMinimize = () => {
        setIsMaximized(false);
    };

    const handleClose = () => {
        sceneViewer.setMenu('roof');
    }

    return (
        <>
            <Tooltip placement="left" title={"Show Packing Slip"}>
                <Button
                    type="default"
                    size="large"
                    className={`float_button ${isMaximized ? 'hide' : ''}`}
                    onClick={handleMaximize}
                    icon={<Package size={28} />}
                />
            </Tooltip>

            <Collapse accordion={false} expandIconPosition="end">
                <div
                    className={`popup ${isMaximized ? 'maximized': 'collapse'}`}
                >
                    <div className="top_bar">
                        <Button
                            title={"Minimize"}
                            type="text"
                            icon={<PictureInPicture size={32} color="#fcfcfc" />}
                            onClick={handleMinimize}
                        >
                        </Button>
                        <b style={{ color: "white" }}>
                            Packing Slip
                        </b>
                        <Button
                            type="text"
                            title={"Close Packing Slip"}
                            className="max_min" onClick={handleClose}>
                                <MdClose size={24} color="#fcfcfc" />
                        </Button>
                    </div>
                    <div className={`popup__content`}>
                        <div className="popup__content__container">
                            <PackingSlip />
                        </div>
                    </div>
                </div>
            </Collapse>
        </>
    );

}

export default PackingSlipPopup;
